import { ReactComponent as IconChevronDown } from '@/assets/svgs/chevron-down.svg'
import { ReactComponent as IconChevronRight } from '@/assets/svgs/chevron-right.svg'
import {ReactComponent as IconInformation} from '@/assets/svgs/DS_Icon_info.svg'
import { ReactComponent as IconNoMessage } from '@/assets/svgs/no-message.svg'
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Modal from "@/componentsDS/Modal/Modal";
import Tabs, { Tab } from '@/components/Tabs'
import Toast from '@/components/Toast'
import OverViewFilter from '@/components/OverViewFilter'
import useAudit from '@/hooks/use-audit'
import useModal from '@/hooks/use-modal'
import usePage from '@/hooks/use-page'
import useToast from '@/hooks/use-toast'
import API_AUDIT from '@/services/api/audit.js'
import titleCase from '@/utils/title-case'
import { orderBy } from 'lodash'
import moment from 'moment'
import { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Loader from '@/components/DataTableLoader/index'
import { feature } from '@/utils/feature-verifier'
import { featureConstant } from '@/constants/configuration/feature'
import Tags from '@/componentsDS/Tags/Tags';
import Breadcrumbs from '@/componentsDS/Breadcrumbs/index'
import Button from '@/componentsDS/Button/Button';
import { ButtonType, ButtonVariant } from '@/componentsDS/Button/Button.type';
import LoadingPortal from '@/components/LoadingPortal/index';
import { useFeature } from "@/hooks/use-feature/index.js";
import { renderUserEmailInline, renderUserEmailStacked, getTooltipAttributes } from '@/utils/formatUserEmail';

const Page = () => {

	/*=================================================
		General
	/================================================*/
	const isSoftDeleteUserEnabled = useFeature(featureConstant.SOFT_DELETE_USER);
	const userTypes = {
		participant: "participant",
		admin: "admin",
		nonParticipant: "nonParticipant"
	}

	const toastType = {
		success: "success",
		error: "error"
	}
	const isActivityLogEnhancementEnabled = useFeature(featureConstant.ACTIVITY_LOG_ENHANCEMENT) ?? false;

	const userType = useSelector(state => state.auth.userType)

	const [pageTitle] = useState("Activity Log")

	const { breadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs:[
			{
				label: '',
				link: `/`,
			},
			{
				label: pageTitle,
				link: ``
			},
		]
	 })

	const pageLimit = 10


	const [auditType, setAuditType] = useState()
	const [auditAction, setAuditAction] = useState()
	const [auditPage, setAuditPage] = useState()
	const [auditPageByTab, setAuditPageByTab] = useState()
	const [auditStatus, setAuditStatusFn] = useState()

	/*=================================================
		Options
	/================================================*/


	/*=================================================
		API
	/================================================*/

	const { toastList, addToastMessage } = useToast()

	const { itemsAudit: auditItems, fetchAudit: fetchAudits, metaAudit: auditMeta, viewAudit, currentItemAudit: currentAudit, errorAudit, loadingAudit } = useAudit()

	useEffect(() => {
		async function getData() {
			const [errorAudit, responseAudit] = await API_AUDIT.getAuditEnum()

			if (errorAudit) {
				return addToastMessage(errorAudit, toastType.error)
			}

			const defaultAuditType = addSelected(responseAudit.type)

			defaultAuditType[0].$selected = true

			setAuditType(defaultAuditType)
			setAuditAction(addSelected(responseAudit.action))
			const auditPageInit = orderBy(addSelected(responseAudit.page), [option => option.name], "asc")
			setAuditPage(auditPageInit)

			setAuditPageByTab(auditPageInit.filter(item=> item.type === defaultAuditType[0].id))

			setAuditStatusFn(addSelected(responseAudit.status))
		}
		getData()
	}, []);

	useEffect(()=>{
		addToastMessage(errorAudit, toastType.error)
	}, [errorAudit])

	function handleChangeType(type) {
		setAuditPageByTab(auditPage?.filter(item=> item.type === type))
	}

	function fetchAuditHandler(){
		const currentType = auditType?.find(audit => audit.$selected === true).id
		fetchAudits({
			currentPage: currentPage,
			pageSize: pageLimit,
			dateFrom: startDate !== null ? moment(startDate).format('yyyy-MM-DD HH:mm Z') : null,
			dateTo: endDate !== null ? moment(endDate).format('yyyy-MM-DD HH:mm Z') : null,
			type: currentType ?? "USER_ACTIVITY",
			action: convertArrayToString(auditAction) ?? null,
			status: convertArrayToString(auditStatus) ?? null,
			page: convertArrayToString(auditPageByTab) ?? null
		})
	}

	/*=================================================
		Modal
	/================================================*/

	const { visible: detailVisible, show: detailShow, hide: detailHide } = useModal()

	/*=================================================
		Tabs
	/================================================*/

	function selectTab(item) {
		const index = auditType?.findIndex(option => option.id === item.id)
		const tabs = [...auditType].map(item => ({ ...item, $selected: false }))

		handleChangeType(item.id)
		setAuditType(tabs)
		tabs[index].$selected = true
	}

	/*=================================================
		Options
	/================================================*/

	//Date
	const [startDate, setStartDate] = useState(isActivityLogEnhancementEnabled ? moment().subtract(1, 'months').startOf('day').toDate() : null);
	const [endDate, setEndDate] = useState(isActivityLogEnhancementEnabled ? moment().toDate() : null);

	useEffect(() => {
		if (!isActivityLogEnhancementEnabled || moment(startDate).isAfter(endDate)) {
			setEndDate(null);
		}
	}, [startDate]);

	/*=================================================
		Sort
	/================================================*/



	/*=================================================
		Paginate
	/================================================*/

	const [currentPage, setCurrentPage] = useState(1)
	const [inputPage, setInputPage] = useState(1)

	useEffect(() => {
		fetchAuditHandler()
	}, [currentPage, startDate, endDate, auditType, auditAction, auditPageByTab, auditStatus])

	function goToPrev() {

		if (currentPage === 1) {
			return
		}

		setCurrentPage(prev => {
			setInputPage(prev - 1)
			return prev - 1
		})
	}

	function goToNext() {
		if (currentPage === auditMeta?.totalPages) {
			return
		}
		setCurrentPage(prev => {
			setInputPage(prev + 1)
			return prev + 1
		})
	}

	useEffect(()=> {
		if(currentPage > auditMeta?.totalPages){
			setCurrentPage(auditMeta?.totalPages || 1)
		}
	}, [auditItems])

	/*=================================================
		Data Table
	/================================================*/

	let timeout

	function handleCurrentInput(e) {
		const value = e.target?.value
		const current = parseInt(value)

		clearTimeout(timeout)
		setInputPage(current)

		if(!e.target.value){
			return
		}

		if(e.target.value > auditMeta?.pageCount){
			return
		}

		timeout = setTimeout(() => {
			if (current > auditMeta.totalPages) {
				return setCurrentPage(auditMeta.totalPages)
			}
			setCurrentPage(current)
		}, 1500)
	}

	function getName(array, id, type){
		if(!array) {
			return
		}

		if(typeof type !== "undefined"){
			return array.find(item=> item.id === id && item.type === type)?.name || titleCase(id)
		}
		return array.find(item=> item.id === id)?.name ?? titleCase(id)
	}

	function statusTag(status) {
		const statusText = status?.charAt(0).toUpperCase() + status?.slice(1).toLowerCase();
		return (
			<>
				{status === "SUCCESS" && <Tags label={statusText} tagClassName="DS__tag--success" />}
				{(status === "FAIL" || status === "ERROR") && <Tags label={statusText} tagClassName="DS__tag--critical" />}
			</>
		)
	}

	const DataTable = ({itemData, title}) =>{

		const list = itemData.map((item,index) => {
			return (
				<div className="data-table__table__body__row" key={index}>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--break">
						{moment(item.timestamp).format('DD/MM/YYYY h:mma')}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--heavy data-table__table__body__content--break">
						{item.remarks || item.content.method + " " + item.content.url}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--break account-settings__modal_term-list__term-date" {...getTooltipAttributes(isSoftDeleteUserEnabled, item.email)}>
						{isSoftDeleteUserEnabled ? renderUserEmailStacked(item?.email) : item?.email}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--break">
						{getName(auditPage, item.page, auditType?.find(type=> type.$selected === true).id)}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--break">
						{getName(auditAction, item.action)}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--break">
						{statusTag(item.status.toUpperCase())}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content__button data-table__table__body__content--flex-end" id="activity-log-view-details">
						<span data-testid="view-btn" className="data-table__table__body__content__action link"
							id="activity-log-view-details"
							onClick={()=>{
								viewAudit(item.id)
								detailShow()
							}}
							role="button" tabIndex={0}
							onKeyDown={(e) => {if (e.key === 'Enter') {
								viewAudit(item.id)
								detailShow()
							}}}
							aria-label="Open audit detail modal"
						>
							<IconChevronRight id="activity-log-view-details" />
						</span>
					</div>
				</div>
			)
		})

		function getPageStart(pageSize, pageNr) {
			return pageSize * pageNr;
		};

		function getPageLabel(total, pageSize, pageNr) {

			const start = Math.max(
				getPageStart(pageSize, pageNr),
				0
			);
			const end = Math.min(
				getPageStart(pageSize, pageNr + 1),
				total
			);

			return `${start + 1} - ${end}`;
		}

		const NoMessage = () =>{
			return (
				<div className="data-table__empty__icon">
					<IconNoMessage/>
					<span>No audit trail found</span>
				</div>
			)
		}

		return (
			<div className="data-table__content">
				<div className="data-table__content__cols">
					<div className="data-table__content__col">
						<div className="data-table__table">
							<div className="data-table__table__head">
								<div className="data-table__table__head__row">
									<div className="data-table__table__head__row__left">
										{title}
									</div>
									<div className="data-table__table__head__row__right">

									</div>
								</div>
								<div className="data-table__table__head__row">
									<div className="data-table__table__head__title">
										Date/Time
									</div>
									<div className="data-table__table__head__title">
										Event
									</div>
									<div className="data-table__table__head__title">
										User
									</div>
									<div className="data-table__table__head__title">
										Page
									</div>
									<div className="data-table__table__head__title">
										Action
									</div>
									<div className="data-table__table__head__title">
										Status
									</div>
									<div className="data-table__table__head__title data-table__table__head__title--flex-end"></div>
								</div>

							</div>
							<Loader loading={isActivityLogEnhancementEnabled ? loadingAudit : false}>
								<div className="data-table__table__body">
										{ list.length > 0 ?
											list :
											<div className="data-table__empty"><NoMessage/></div>
										}
								</div>
								{
									list.length > 0 && (
										<div className="data-table__table__footer">
											<div className="data-table__table__footer__row">
												<div className="data-table__table__footer__row__left">
													<div className="data-table__table__pagination">
														<input data-testid="pagination-input" className="data-table__table__pagination__page" type="number" value={inputPage} onChange={(e)=> handleCurrentInput(e)} min="1" />
														<span className="data-table__table__pagination__page__meta"> of {auditMeta?.pageCount || 1} pages </span>
														<button data-testid="pagination-prev" className="data-table__table__pagination__prev" onClick={()=>goToPrev()} disabled={currentPage === 1}><IconChevronDown/></button>
														<button data-testid="pagination-next" className="data-table__table__pagination__next" onClick={()=>goToNext()} disabled={currentPage === auditMeta?.pageCount}><IconChevronDown/></button>
													</div>
												</div>
												<div className="data-table__table__footer__row__right">
													<div className="data-table__table__meta">
														Showing {getPageLabel(auditMeta?.count, pageLimit, currentPage-1) } of {auditMeta?.count || 0} entries
													</div>
												</div>
											</div>
										</div>
									)
								}
							</Loader>
						</div>
					</div>
				</div>
			</div>
		)
	}

	/*=================================================
		Additional Functions
	/================================================*/

	function addSelected(array) {
		return array.map(item => {return {...item, $selected: false } }  )
	}

	function retrieveId(array){
		let resultArr = [];

		array.forEach(item => {
			if(item.$selected){
				resultArr.push(item.id)
			}
		})

		return resultArr
	}

	function convertArrayToString(array){

		if (!Array.isArray(array)) {
			return null
		}

		if(array.every(item=> item.$selected === true)){
			return null
		}

		const tempArray = retrieveId(array)

		if (tempArray.length >0 ){
			return tempArray.toString();
		}

		return null
	}

	function setFalse(array, setArray){
		const updatedItem = array.map(field=> ({...field, $selected: false}))
		setArray(updatedItem)
	}

	function resetFilter(){
		setFalse(auditAction, setAuditAction)
		setFalse(auditPageByTab, setAuditPageByTab)
		setFalse(auditStatus, setAuditStatusFn)

		setStartDate(null)
		setEndDate(null)
	}

	const overViewData = {
		startDate,
		setStartDate,
		endDate,
		setEndDate,
		auditPageByTab,
		setAuditPageByTab,
		auditAction,
		setAuditAction,
		auditStatus,
		setAuditStatusFn,
		resetFilter
	}

	return (
		<>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />

			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">
						{pageTitle}
					</div>
				</div>
				<div className="title-header__right"></div>
			</div>

			<div className="api-configuration__header">
				{userType === userTypes.admin && (
					<Tabs>
						{auditType && auditType.map((item, index)=> (
							<Tab key={index} label={item.name} active={item.$selected} onClick={() => selectTab(item)} id={'audit-trail-' + item.id.toLowerCase()} />
						))}
					</Tabs>
				)}

				{userType !== userTypes.admin && (
					<Tabs>
						{auditType && auditType.filter(type => type.id !== "ADMIN_ACTIVITY").map((item, index)=> (
							<Tab key={index} label={item.name} active={item.$selected} onClick={() => selectTab(item)} id={'audit-trail-' + item.id.toLowerCase()} />
						))}
					</Tabs>
				)}
			</div>

			<div className="title-header__hr">
				<hr />
			</div>

			<div className="overview overview--margin-top">
				{auditType?.map((item,index) => {
					return (
						<Fragment key={index}>
							{item.id.toLowerCase() === "user_activity" && item.$selected === true && (
								<OverViewFilter { ...overViewData }>
									{DataTable({itemData: auditItems, title: item.name})}
								</OverViewFilter>
							)}
							{item.id.toLowerCase() === "system" && item.$selected === true && (
								<OverViewFilter { ...overViewData }>
									{DataTable({itemData: auditItems, title: item.name})}
								</OverViewFilter>
							)}
							{item.id.toLowerCase() === "admin_activity" && item.$selected === true && (
								<OverViewFilter { ...overViewData }>
									{DataTable({itemData: auditItems, title: item.name})}
								</OverViewFilter>
							)}
						</Fragment>
					)
				})}
			</div>


			<Modal visible={detailVisible} variant='large' close={detailHide}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className='card-configure__title__left--background'>
											<div className='DS__icon'>
												<IconInformation />
											</div>
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Detail
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className='audit-trail-container'>
								<div className='audit-trail-container--left audit-trail-container--layout'>
									<div>User</div>
									<div>Page</div>
									<div>Event</div>
									<div>Type</div>
									<div>Action</div>
									<div>Status</div>
									<div>Date</div>
								</div>
								{currentAudit && (
									<div className='audit-trail-container--right audit-trail-container--layout'>
										<div>{isSoftDeleteUserEnabled ? renderUserEmailInline(currentAudit?.email) : currentAudit?.email}</div>
										<div>
											{getName(auditPage, currentAudit.page, auditType?.find(type => type.$selected === true).id)}
										</div>
										<div>
											{currentAudit?.remarks || currentAudit?.content.method + " " + currentAudit?.content.url}
										</div>
										<div>
											{getName(auditType, currentAudit?.type)}
										</div>
										<div>
											{getName(auditAction, currentAudit?.action)}
										</div>
										<div>
											<span>
												{statusTag(currentAudit?.status.toUpperCase())}
											</span>
										</div>
										<div>
										{moment(currentAudit?.timestamp).format('DD/MM/YYYY h:mma')}
										</div>
									</div>
								)}
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button variant={ButtonVariant.STANDARD} type={ButtonType.SOLID} text="Close" onClick={() =>detailHide()}>Close</Button>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Toast toastList={toastList}  />
			<LoadingPortal isLoading={loadingAudit}/>
		</>
	)
}

export default Page
